import logo from './logo.svg';
import './App.css';
import {BrowserRouter as Router,
Routes,
Route,
Link} from 'react-router-dom';
import Home from './component/home';
import About from './component/about';
import PrivacyPolicy from './component/privacy-policy'
import CookiePolicy from './component/cookies-policy';
import MPSTermsConditions from './component/termsandconditions';
import MPSTermsConditionsCard from './component/termsandconditionscard';


function App() {
  return (
    <Router>
      <div className="App"/>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/about' element={<About/>}/>
        <Route path='/termsandconditions' element={<MPSTermsConditions/>}/>
        <Route path='/termsandconditioncard' element={<MPSTermsConditionsCard/>}/>
        <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
        <Route path='/cookies-policy' element={<CookiePolicy/>}/>
      </Routes> 
    </Router>
  );
}

export default App;
